<template>
  <div>
    <b-col cols="12" class="p-3 mb-2" style="border:solid 1px #DFDFDF;">
      <div class="text-left">
        <span>
          <b-badge variant="warning">Alert {{(alertIndex+1)}}</b-badge>
        </span>
        <!-- <font-awesome-icon :icon="alert.ent_tp == 'P' ? 'male' : 'building'" />
                                        <span class="ml-4">
                                            <b-badge>Source</b-badge>: {{alert.ent_src_name}}
        </span>-->
        <span class="ml-4" v-if="!alertCollapse">
          <strong>{{alert.ent_name}}</strong>
        </span>

        <span class="ml-4" v-for="(category, index) in uniqueCategories" :key="index">
          <b-badge variant="dark" class="mr-3">{{category[0]}}: {{category[1]}}</b-badge>
        </span>

        <!-- <span class="ml-4" v-if="!alertCollapse">
                <b-badge>Waldo</b-badge>: Probable Match
        </span>-->
        <!-- <span class="ml-4" v-if="!alertCollapse">
                <b-badge>Match Score</b-badge>: 10%
            </span>
            <span class="ml-4" v-if="!alertCollapse">
                <b-badge>Predictive Match</b-badge>:No
        </span>-->
        <span class="ml-4" v-if="!alertCollapse && alertStatus=='pending'">
          <b-badge variant="primary">{{alertStatus}}</b-badge>
        </span>
        <span
          class="ml-4"
          v-if="!alertCollapse && (alertStatus!='pending' && alertStatus!='refer to ethixbase')"
        >
          <b-badge :variant="alertStatus=='negative alert' ? 'success': 'danger'">{{alertStatus}}</b-badge>
        </span>

        <b-button
          @click="alertCollapse = !alertCollapse"
          variant="primary"
          class="float-right"
          size="sm"
        >
          <font-awesome-icon :icon="alertCollapse ? 'minus' : 'plus'" />
        </b-button>
      </div>

      <div class="clearfix"></div>
      <b-collapse id="collapse-2" class="mt-2" v-model="alertCollapse">
        <h3>
          <small>
            <span class="mr-1">
              <b-badge variant="warning">Alert {{(alertIndex+1)}}</b-badge>
            </span>
          </small>
          {{alert.ent_name}}
          <span class="ml-4" v-if="alertStatus=='pending'">
            <small>
              <b-badge variant="primary">{{alertStatus}}</b-badge>
            </small>
          </span>
          <span class="ml-4" v-if="alertStatus!='pending' && alertStatus!='refer to ethixbase'">
            <small>
              <b-badge
                :variant="alertStatus=='negative alert' ? 'success': 'danger'"
              >{{alertStatus}}</b-badge>
            </small>
          </span>
        </h3>

        <b-tabs content-class="mt-3 text-left">
          <b-tab :title="'Remediate Alert '+(alertIndex+1)" active>
            <b-row>
              <b-col cols="6" style="max-height:400px;overflow-y:auto;">
                <b-card no-body>
                  <b-nav pills card-header slot="header" v-b-scrollspy:nav-scroller>
                    <b-nav-item
                      href="#sources"
                      @click="scrollIntoView"
                    >Sources ({{JSON.parse(alert.ent_evnt).length}})</b-nav-item>
                    <b-nav-item href="#sources-info" @click="scrollIntoView">Sources Information</b-nav-item>

                    <b-nav-item href="#aliases" @click="scrollIntoView">Alaises</b-nav-item>
                    <b-nav-item href="#addresses" @click="scrollIntoView">Addresses</b-nav-item>
                    <b-nav-item href="#attributes" @click="scrollIntoView">Attributes</b-nav-item>
                  </b-nav>

                  <b-card-body
                    id="nav-scroller"
                    ref="content"
                    style="position:relative; height:300px; overflow-y:scroll;"
                  >
                    <h4 id="sources">Sources</h4>
                    <b-row v-for="(event,eventIndex) in JSON.parse(alert.ent_evnt)">
                      <b-col cols="12">
                        <p>
                          <span>
                            <strong>Source Name:</strong>
                          </span>
                          &nbsp;{{event.ent_src_name || "Not Available"}}
                        </p>
                        <p>
                          <span>
                            <strong>Source Date:</strong>
                          </span>
                          &nbsp; {{event['source date'] || "Not Available"}}
                        </p>
                        <!-- <p><span><strong>PEP:</strong></span> &nbsp; <b-badge variant="warning">Yes</b-badge>
                        </p>-->
                        <p>
                          <span>
                            <strong>Source:</strong>
                          </span>
                          &nbsp;{{alert.ent_src_name || "Not Available"}}
                        </p>
                        <p>
                          <span>
                            <strong>Category:</strong>
                          </span>&nbsp;
                          <b-badge
                            :id="'category-tooltip-target-'+eventIndex+'-'+alert.id"
                            variant="primary"
                          >{{event.category || "Not Available"}}</b-badge>
                        </p>
                        <b-tooltip
                          :target="'category-tooltip-target-'+eventIndex+'-'+alert.id"
                        >Catgeory tooltip, need to make this dynamic</b-tooltip>
                        <p>
                          <span>
                            <strong>Description:</strong>
                          </span>&nbsp;
                          <span v-html="sanitizeHtml(event.description || 'Not Available')"></span>
                        </p>
                        <p>
                          <span>
                            <strong>Sub Category:</strong>
                          </span>&nbsp;
                          <b-badge
                            variant="primary"
                            :id="'subcategory-tooltip-target-'+eventIndex+'-'+alert.id"
                          >{{event.subCategory || "Not Available"}}</b-badge>
                        </p>
                        <b-tooltip
                          :target="'subcategory-tooltip-target-'+eventIndex+'-'+alert.id"
                        >Sub Catgeory tooltip, need to make this dynamic</b-tooltip>
                        <hr v-if="alertIndex>0" />
                      </b-col>
                    </b-row>
                    <h4 id="sources-info">Sources Information</h4>
                    <div v-for="(source) in JSON.parse(alert.ent_sources)">
                      <p v-if="source.name">
                        <span v-html="sanitizeHtml(source.name)"></span>
                      </p>
                      <p v-if="source.url">
                        <strong>URL:</strong>
                        <a :href="source.url" target="_blank">{{source.url}}</a>
                      </p>
                    </div>

                    <h4 id="aliases">Aliases</h4>
                    <p v-html="sanitizeHtml(getAlaises(alert.ent_alias))"></p>

                    <h4 id="addresses">Addresses</h4>
                    <p v-html="sanitizeHtml(getAddress(alert.ent_address) || 'No information')"></p>

                    <h4 id="attributes">Attributes</h4>
                    <div v-for="(atribute) in JSON.parse(alert.ent_attri)">
                      <p v-if="atribute.code">
                        <b-badge variant="primary">
                          <span v-html="sanitizeHtml(atribute.code)"></span>
                        </b-badge>
                        : {{atribute.value || 'N/A'}}
                      </p>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="6">
                <b-card header="Remediation status" header-tag="header">
                  <b-row>
                    <b-col cols="12">
                      <!-- <toggle-button :value="true" v-model="alertStatus" color="#82C7EB" :labels="true" /> -->

                      <b-form-radio-group
                        v-model="alertStatus"
                        @change="onUpdateStatus($event, alert)"
                        :options="remediationOptions"
                      ></b-form-radio-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group label="Remediation Comments">
                        <b-form-textarea
                          placeholder="Enter something..."
                          rows="3"
                          max-rows="6"
                          required
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <b-form-group
                        label="Action taken to clear/confirm the alerted name(i.e. how)"
                      >
                        <b-form-textarea
                          placeholder="Enter something..."
                          rows="3"
                          max-rows="6"
                          :disabled="alertStatus=='pending'"
                          required
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <h3>Upload Supporting documentation</h3>
                      <vue-dropzone
                        ref="myVueDropzone"
                        @vdropzone-success="vsuccess"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-sending="sendingEvent"
                        @vdropzone-upload-progress="onUploadImage"
                        @vdropzone-queue-complete="onUploadFinish"
                        :useCustomSlot="true"
                      >
                        <div class="dropzone-custom-content">
                          <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                          <div class="subtitle">...or click to select a file from your computer</div>
                        </div>
                      </vue-dropzone>
                    </b-col>
                    <b-col cols="12">
                      <table class="table table-striped">
                        <thead class="thead-dark">
                          <tr>
                            <th></th>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Size</th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                      </table>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
          <!-- <b-tab title="Attributes">
                    <div v-for="(atribute,index) in JSON.parse(alert.ent_attri)" :key="index">
                        <p>
                            <b-badge variant="primary"><span v-html="atribute.code"></span></b-badge> : {{atribute.value}}
                        </p>

                    </div>
          </b-tab>-->
          <!-- <b-tab title="Source information">
                    <div v-for="(source,index) in JSON.parse(alert.ent_sources)" :key="index">
                        <p><span v-html="source.name">Name: {{source.name}}</span></p>
                        <p>URL: {{source.url}}</p>
                    </div>

          </b-tab>-->
          <!-- <b-tab title="Addresses">
                    <p v-html="alert.ent_address || 'No information'"></p>
          </b-tab>-->
          <!-- <b-tab title="Alaises">
                    {{getAlaises(alert.ent_alias)}}
                    
          </b-tab>-->

          <!-- <b-tab title="Waldo" v-if="entityType=='P'">
                    <waldo-alert-match></waldo-alert-match>
          </b-tab>-->
          <!-- <b-tab title="Predictive Match"></b-tab> -->
        </b-tabs>
      </b-collapse>
    </b-col>
  </div>
</template>

<script>
import waldoAlertMatch from "./waldo-alert-match.vue";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import { mapGetters, mapState } from "vuex";
import vue2Dropzone from "../Dropzone/VueDropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "RDCAlert",
  components: {
    waldoAlertMatch,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      files: [],
      dropzoneOptions: {
        //url: 'https://httpbin.org/post',
        url: process.env.VUE_APP_API_URL + "v1/uploads/file/form",
        thumbnailWidth: 150,
        maxFilesize: 10,

        //parallelUploads:50,
        // addRemoveLinks: true,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        }
      },
      text: `
          Quis magna Lorem anim amet ipsum do mollit sit cillum voluptate ex nulla
          tempor. Laborum consequat non elit enim exercitation cillum aliqua
          consequat id aliqua. Esse ex consectetur mollit voluptate est in duis
          laboris ad sit ipsum anim Lorem. Incididunt veniam velit elit elit veniam
          Lorem aliqua quis ullamco deserunt sit enim elit aliqua esse irure. Laborum
          nisi sit est tempor laborum mollit labore officia laborum excepteur
          commodo non commodo dolor excepteur commodo. Ipsum fugiat ex est consectetur
          ipsum commodo tempor sunt in proident.
        `,

      alertCollapse: false,
      alertStatus: "pending",
      date: null,
      remediationOptions: ["pending", "postive alert", "negative alert"],
      riskCategories: ["REC", "ABC", "CVC"],
      riskSubCatgeories: ["EFG", "HIJ", "LMN", "OPQ", "RST"],
      riskSources: ["RiskConnect", "OFAC", "Factiva", "Bloomsberg"],
      rdcDictionaryEntityAttributeCode: [
        {
          ADR: "Address",
          ALS: "Alias",
          ADR: "Address",
          ASC: "Association"
        }
      ],
      rdcDictionaryEventCategoryCode: [{}],
      rdcDictionaryEventSubCategoryCode: [{}],

      // for ctegories
      uniqueCategories: [],
      uniqueSubCategories: [],
      secUniqueCount: 0
    };
  },
  created() {},
  mounted() {
    // // console.log("alert in RDC alert", JSON.parse(this.alert.ent_evnt))
    this.alertStatus = "pending";
    this.getUniqueCategories(this.alert.ent_evnt);
  },
  validations: {},
  computed: {
    ...mapGetters([]),
    ...mapState(["toggleAllCoppalse"])
  },
  watch: {
    toggleAllCoppalse(value) {
      this.collapse = value;
    }
  },
  methods: {
    sanitizeHtml,
    readableBytes(bytes) {
      var i = Math.floor(Math.log(bytes) / Math.log(1024)),
        sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + " " + sizes[i];
    },

    onUploadImage(file, progress, bytesSent) {
      // console.log("uploading....");
      EventBus.$emit("onUploadStart", "uploading image");
    },

    onUploadFinish() {
      // console.log("finsish....");
      EventBus.$emit("onUploadCompleting", "uploading image");
    },

    vsuccess(file, response) {
      //this.isFocus = false;
      //this.$store.state.validFields = true;
      // // console.log("file, response", file, response);
      let self = this;
      let uploadedFile = {};
      if (response && response.url) {
        this.imgSrc = response.url;
        uploadedFile = {
          fileId: uid(),
          filename: file.name,
          caption: { english: this.slideCaption },
          text: { english: this.slideText },
          size: file.size,
          type: file.type,
          url: response.url
        };
        self.files.push(uploadedFile);
        // this.$refs.myVueDropzone.removeAllFiles();
        this.$refs.myVueDropzone.removeFile(file);
      }
    },

    /**
     * dropzone js send additional params
     */
    sendingEvent(file, xhr, formData) {
      formData.append("formId", this.form.formId);
      formData.append("fieldId", this.fieldData.id);
      formData.append("fieldIndex", this.fieldIndex);
      formData.append("sectionIndex", this.fieldIndex);
      formData.append("sectionId", this.fieldIndex);
    },
    // Convenience method to scroll a heading into view.
    // Not required for scrollspy to work
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },

    getAlaises(alais) {
      console.clear;
      let jsn = JSON.parse(alais);
      return jsn.join(", <br />");
      // jsn = jsn.map(value =>{
      //     return value+'Value'
      // })
      // return jsn
      // if (typeof alais === 'string') {
      //     return alais.toString() || 'No Information';
      // }
      // elseif(isArray(alais)) {
      //     return alais.toString() || 'No Information';
      // }
    },

    getAddress(address) {
      let jsn = JSON.parse(address);
      return jsn.join(", <br />");
    },

    // for alerts calculations
    onUpdateStatus(status, alert) {
      // // console.log("onUpdateStatus", status, alert)
      this.$emit("getStatus", status, alert);
    },
    //-----for categories
    getUniqueCategories(alertEvents) {
      let counts = {};
      JSON.parse(alertEvents).forEach(alert => {
        counts[alert.category] = (counts[alert.category] || 0) + 1;
      });
      this.uniqueCategories = Object.entries(counts);
    }
  },
  props: {
    alert: Object,
    alertIndex: Number
  }
};
</script>
